var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpUsercontrol",
    {
      attrs: {
        loading: _vm.loading,
        reloading: _vm.reloading,
        loaded: _vm.loaded,
        error: _vm.error
      },
      on: {
        reload: function($event) {
          return _vm.evh_7315092382398562_reload($event, {})
        }
      }
    },
    [
      _c("legend", { staticClass: "text-muted" }, [
        _vm._v(
          "\n    " + _vm._s(_vm._f("pgettext")("General", "Contract")) + "\n  "
        )
      ]),
      _vm._v(" "),
      _vm.filteredCategories && _vm.filteredCategories.length
        ? _c(
            "ItpFormGroup",
            {
              attrs: {
                name: "category",
                label: _vm._f("gettext")("Category"),
                labelColsMd: "4",
                contentColsMd: "2"
              }
            },
            [
              _c("ItpFormSelect2", {
                attrs: {
                  name: "category",
                  "bind-object": "",
                  textField: "name",
                  options: _vm.filteredCategories
                },
                model: {
                  value: _vm.contract.category,
                  callback: function($$v) {
                    _vm.$set(_vm.contract, "category", $$v)
                  },
                  expression: "contract.category"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "ItpFormGroup",
        {
          attrs: {
            name: "revision_number",
            label: _vm._f("pgettext")("Revision number", "Contract"),
            labelColsMd: "4",
            contentColsMd: "2",
            labelAlign: _vm.labelAlign,
            required: ""
          }
        },
        [
          _c("ItpFormInput", {
            attrs: { type: "number", name: "revision_number", required: "" },
            model: {
              value: _vm.contract.revision_number,
              callback: function($$v) {
                _vm.$set(_vm.contract, "revision_number", $$v)
              },
              expression: "contract.revision_number"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ItpFormGroup",
        {
          attrs: {
            name: "contract_type",
            label: _vm._f("gettext")("Contract type"),
            labelColsMd: "4",
            contentColsMd: "8",
            labelAlign: _vm.labelAlign,
            required: ""
          }
        },
        [
          _c("ItpFormSelect2", {
            attrs: {
              name: "contract_type",
              options: _vm.contractTypes,
              valueField: "value",
              textField: "text",
              required: ""
            },
            model: {
              value: _vm.contract.contract_type,
              callback: function($$v) {
                _vm.$set(_vm.contract, "contract_type", $$v)
              },
              expression: "contract.contract_type"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ItpFormGroup",
        {
          attrs: {
            name: "status",
            label: _vm._f("pgettext")("Status", "Contract"),
            labelColsMd: "4",
            contentColsMd: "4",
            labelAlign: _vm.labelAlign,
            required: ""
          }
        },
        [
          _c("ItpFormSelect2", {
            attrs: {
              name: "status",
              valueField: "value",
              textField: "text",
              options: _vm.statuses,
              required: ""
            },
            model: {
              value: _vm.contract.status,
              callback: function($$v) {
                _vm.$set(_vm.contract, "status", $$v)
              },
              expression: "contract.status"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ItpFormGroup",
        {
          attrs: {
            name: "external_key",
            label: _vm._f("pgettext")("External key", "Contract"),
            labelColsMd: "4",
            contentColsMd: "8",
            labelAlign: _vm.labelAlign
          }
        },
        [
          _c("ItpFormInput", {
            attrs: { name: "external_key" },
            model: {
              value: _vm.contract.external_key,
              callback: function($$v) {
                _vm.$set(_vm.contract, "external_key", $$v)
              },
              expression: "contract.external_key"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }